export enum PostSubmissionError {
  COMPLETE = 'complete',
  CANCELLED = 'cancelled',
  SLOT_NOT_AVAILABLE = 'slotNotAvailable',
  PAST = 'past',
  LESS_24_HR = 'less24hr',
}
